module.exports = __webpack_public_path__ + "img/icon-electronics.c8a92afa.svg";